import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { GetReviewSurveysPayload } from 'ha/services/apiV2/types/ReviewSurvey';
import { ReviewSurveysRequest } from 'ha/services/apiV2/types/ReviewSurveys';

export default (makeCall: MakeCall) => (query: ReviewSurveysRequest) =>
  makeCall<GetReviewSurveysPayload>('GET', `/api/v2/review/surveys`, {
    query,
  });
